export const ru = {
    'ad-decline-req': 'Группы отклонены из-за несоответствия правилам размещения рекламы.',
    'how-to-fix': 'Узнать, как исправить группу, можно в столбце "Статус".',
    'many-group-title': 'Измените {count} групп, чтобы они прошли модерацию',
    'one-group-title': 'Измените {count} группу, чтобы она прошла модерацию',
    'one-group-title-hint': 'Рекомендация показывается, потому что группа не прошла модерацию',
    'open-ad-list': 'Чтобы узнать причины отклонения и исправить их, проверьте объявления и настройки группы.',
    'popup-ad-decline-req': 'Группа отклонена из-за несоответствия правилам размещения рекламы',
    'several-group-title-hint': 'Рекомендация показывается, потому что некоторые группы не прошли модерацию',
    'show-many-group-button': 'Посмотреть {count} групп',
    'show-one-group-button': 'Посмотреть {count} группу',
    'show-some-group-button': 'Посмотреть {count} группы',
    'simple-title': 'Измените группу, чтобы она прошла модерацию',
    'some-group-title': 'Измените {count} группы, чтобы они прошли модерацию',
    'twenty-one-group-title': 'Измените {count} группу, чтобы они прошли модерацию'
};
